interface ToggleProps {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  tooltip?: string;
  disabled?: boolean;
}

export function Toggle({ label, checked, onChange, tooltip, disabled }: ToggleProps) {
  return (
    <label className="flex cursor-pointer items-center justify-between gap-3 py-1">
      <span className="flex items-center gap-1 text-xs font-medium text-slate-600 dark:text-slate-300">
        {label}
        {tooltip && (
          <span title={tooltip} className="cursor-help text-slate-400" aria-label={tooltip}>
            ⓘ
          </span>
        )}
      </span>
      <span className="relative inline-block h-5 w-9 shrink-0">
        <input
          type="checkbox"
          className="peer sr-only"
          checked={checked}
          disabled={disabled}
          onChange={(e) => onChange(e.target.checked)}
          aria-label={label}
        />
        <span className="absolute inset-0 rounded-full bg-slate-300 transition-colors peer-checked:bg-brand-600 peer-disabled:opacity-50 dark:bg-slate-600" />
        <span className="absolute left-0.5 top-0.5 h-4 w-4 rounded-full bg-white transition-transform peer-checked:translate-x-4" />
      </span>
    </label>
  );
}
